export const EMAIL_GROUPS = [
  {
    key: 'payments',
    label: 'Payments',
    description: 'New plans, activated plans, declined payments, payments that need billing, payment link updates.',
  },
  {
    key: 'status',
    label: 'Status changes',
    description: 'Retention, cancelled and other status changes, suspended or reactivated clients, welcome calls completed.',
  },
  {
    key: 'documents',
    label: 'Documents',
    description: 'Documents added by affiliates.',
  },
  {
    key: 'notes',
    label: 'Notes and messages',
    description: '@mentions in notes, client portal messages, office copies of notes.',
  },
  {
    key: 'tasks',
    label: 'Task reminders',
    description: 'Reminders for tasks you are set to be reminded about.',
  },
  {
    key: 'qc',
    label: 'QC calls',
    description: 'QC call results and failures.',
  },
]

export const orderGroupKeys = (keys) => {
  const wanted = Array.isArray(keys) ? keys : []
  return EMAIL_GROUPS.filter((group) => wanted.includes(group.key)).map((group) => group.key)
}

export const groupLabels = (keys) => {
  const wanted = Array.isArray(keys) ? keys : []
  return EMAIL_GROUPS.filter((group) => wanted.includes(group.key)).map((group) => group.label)
}
